<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
            
                <!-- Header Meta !-->
                <table-meta-element 
                    :hide-nav="true" 
                    :hide-nav-on-no-pages="false" 
                    title="Finance" 
                    item-type="finance deals"
                    :show-loading="true"
                >
                    <div slot="title" class="dropdown" style="display: inline-block;">
                        <title-view-selector
                            :title="title"
                            :options="viewOptions"
                            @select="viewSelected"
                        ></title-view-selector>
                    </div>
                </table-meta-element>

                <!-- Instance Table !-->
                <div class="table-responsive">
                    <table class="table finance-table" style="min-width: 2500px;">
                    <thead v-if="tableHeaderColumns.length > 0">
                        <th v-for="column in tableHeaderColumns" :key="column.label" :style="column.style ? column.style : ''">
                            <span>{{ column.label }}</span>
                        </th>
                    </thead>
                    <tbody v-if="hasResults">
                        <tr v-for="(deal, index) in financeDeals" :key="deal.id">
                            <td>
                                <div style="font-size: 1.2rem;">
                                    <a :href="'/contacts/' + deal.invoice.contact_id">{{ deal.invoice.contact.primary_display_as }}</a>
                                </div>
                                <div style="font-size: .8rem" v-if="deal.instance">
                                    <a :href="$root.buildUrl('vehicles/' + deal.instance.id + '/overview')" class="registration" style="display: inline-block; margin-top: 5px; font-size: .7em; width: 60px; margin-right: 5px; padding: .45em 0; color: #42526e; font-weight: 500;">{{ deal.instance.vehicle.registration.formatted_vrm }}</a>
                                    <a v-if="deal.instance" :href="$root.buildUrl('vehicles/' + deal.instance.id + '/overview')" class="truncate" style="vertical-align: middle; display: inline-block; max-width: 57%;">{{ deal.instance.title }}</a>
                                </div>
                            </td>
                            <td>
                                <a :href="'/deals/' + deal.id + '/edit'">#{{ deal.id }}</a>
                            </td>
                            <td>
                                <div>{{ deal.finance_payment.provider.primary_display_as }}</div>
                                <div v-if="deal.finance_payment.reference" style="max-width: 100%;" class="subtle truncate">{{ deal.finance_payment.reference }}</div>
                            </td>
                            <td>
                                {{ deal.finance_payment.finance_agreement.amount_funded | currency(2) }}
                            </td>
                            <td>
                                <span style="vertical-align: middle;">{{ deal.finance_payment.finance_agreement.total_contra_amount | currency(2) }}</span>
                                <ui-icon-button @click="showContraForAgreement(deal.finance_payment.finance_agreement)" size="mini" icon="open_in_new" color="primary" type="secondary" style="vertical-align: middle;"></ui-icon-button>
                            </td>
                            <td>
                                {{ deal.finance_payment.finance_agreement.payout_amount | currency(2) }}
                            </td>
                            <td>
                                <vue-select
                                    name="type"
                                    placeholder="Select type..."
                                    :options="FinanceTypeKeyValueList"
                                    style="margin-bottom: 0;"
                                    v-model="deal.finance_payment.finance_type"
                                    @input="markDirty(deal)"
                                >
                                </vue-select>
                            </td>
                            <td>
                                <vue-input
                                    label=""
                                    type="text"
                                    placeholder="e.g. 60"
                                    style="margin-bottom: 0; max-width: 150px; display: inline-block;"
                                    v-model="deal.finance_payment.payment_term"
                                    @input="markDirty(deal)"
                                ></vue-input>
                            </td>
                            <td>
                                <vue-input
                                    label=""
                                    type="text"
                                    placeholder="e.g. 1000"
                                    addon-before="&pound;"
                                    style="margin-bottom: 0; max-width: 150px; display: inline-block;"
                                    v-model="deal.finance_payment.finance_monthly_payment"
                                    @input="markDirty(deal)"
                                ></vue-input>
                            </td>
                            <td>
                                <vue-input
                                    v-if="deal.finance_payment.finance_type === FinanceTypes.PCP"
                                    label=""
                                    type="text"
                                    placeholder="e.g. 1000"
                                    addon-before="&pound;"
                                    style="margin-bottom: 0; max-width: 150px; display: inline-block;"
                                    v-model="deal.finance_payment.finance_balloon_payment"
                                    @input="markDirty(deal)"
                                ></vue-input>
                            </td>
                            <td>
                                <vue-select
                                    name="status"
                                    placeholder="Select status..."
                                    :options="financeStatuses"
                                    style="margin-bottom: 0;"
                                    :value="deal.finance_payment.status"
                                    @input="e => { changeFinanceStatus(deal.finance_payment, e) }"
                                >
                                </vue-select>
                            </td>
                            <td>
                                <vue-input
                                    id="paid_at"
                                    :value="formattedPaymentDate(deal.finance_payment.paid_at)"
                                    label=""
                                    name="paid_at"
                                    type="date"
                                    placeholder="e.g. 12/12/2012"
                                    style="margin-bottom: 0;"
                                    :disabled="!deal.finance_payment.is_banked"
                                    @input="e => { changePaidAtDate(deal.finance_payment, e) }"
                                />
                            </td>
                            <td>
                                <vue-input
                                    label=""
                                    type="text"
                                    placeholder="e.g. 1000"
                                    addon-before="&pound;"
                                    style="margin-bottom: 0; max-width: 150px; display: inline-block;"
                                    v-model="deal.finance_payment.finance_agreement.commission_amount"
                                    @input="markDirty(deal)"
                                ></vue-input>
                            </td>
                            <td>
                                <vue-select
                                    name="status"
                                    placeholder="Select method..."
                                    :options="paymentMethodList"
                                    style="margin-bottom: 0;"
                                    :disabled="!deal.finance_payment.is_banked"
                                    :value="deal.finance_payment.finance_agreement.commission_payment_method"
                                    @input="e => { changeCommPaymentMethod(deal.finance_payment, e) }"
                                >
                                </vue-select>
                            </td>
                            <td>
                                <vue-input
                                    id="paid_at"
                                    :value="formattedPaymentDate(deal.finance_payment.finance_agreement.commission_paid_at)"
                                    label=""
                                    name="paid_at"
                                    type="date"
                                    placeholder="e.g. 12/12/2012"
                                    style="margin-bottom: 0;"
                                    :disabled="!deal.finance_payment.is_banked || !deal.finance_payment.finance_agreement.commission_payment_method"
                                    @input="e => { changeCommPaidAtDate(deal.finance_payment, e)  }"
                                />
                            </td>
                            <td>
                                <ui-icon-button 
                                    icon="save" 
                                    style="vertical-align: middle;" 
                                    :color="deal.finance_payment.isDirty ? 'green' : 'default'" 
                                    :disabled="!deal.finance_payment.isDirty"
                                    :loading="deal.finance_payment.isBusy"
                                    @click="save(deal.finance_payment)"
                                />
                            </td>
                        </tr>
                    </tbody>
                    <tr v-if="!hasResults || results.total === 0">
                        <td colspan="13" class="text-center">No finance deals found</td>
                    </tr>
                    <tfoot>
                        <tr>
                            <td colspan="3">
                                <strong>{{ totalAgreements }} agreements</strong>
                            </td>
                            <td>
                                <strong>{{ totalAmountFunded | currency(2) }}</strong>
                            </td>
                            <td>
                                <strong>{{ totalContra | currency(2) }}</strong>
                            </td>
                            <td>
                                <strong>{{ totalPayout | currency(2) }}</strong>
                            </td>
                            <td colspan="6"></td>
                            <td>
                                <strong>{{ totalCommission | currency(2) }}</strong>
                            </td>
                            <td colspan="3"></td>
                        </tr>
                    </tfoot>
                </table>
                </div>

                <!-- Contra Modal !-->
                <finance-agreement-contra-modal ref="contraModal" @saved="get"></finance-agreement-contra-modal>

                <!-- Footer Meta !-->
                <table-meta-element 
                    :hide-on-no-pages="true" 
                    item-type="deals" 
                    style="margin-top: 2rem;"
                ></table-meta-element>
            </div>
        </div>
    </div>
</template>
<script>
    import DataView from '../../components/mixins/DataView';
    import { DealResource, DealLifeCycleStatuses } from '../../classes/Api/Deal';
    import {
        FinanceTypeKeyValueList,
        FinanceTypes,
        PaymentMethodKeyValueList,
        PaymentMethods,
        PaymentResource
    } from '../../classes/Api/Payment';
    import { mapState, mapActions } from 'vuex'
    import InfoButton from "../elements/InfoButton.vue";
    import FinanceAgreementContraModal from "./FinanceAgreementContraModal.vue";
    import {sumBy} from "lodash";
    import Moment from "moment";
    import DealerKit from "../../api";

    export default {
        components: {FinanceAgreementContraModal, InfoButton},
        filters: {
            uppercase(v) {
                return (v) ? v.toUpperCase() : 'TBC'
            }
        },
        mixins: [DataView],
        data() {
            return {
                FinanceTypeKeyValueList,
                FinanceTypes,
                PaymentMethodKeyValueList,
            }
        },
        created() {
            this.setResourceRelations([
                'invoice',
                'invoice.payments',
                'invoice.payments.financeAgreement.financeCompany',
                'invoice.payments.provider'
            ]);

            this.setFilter({
                key: 'deal.finance_status',
                value: 'unbanked'
            })

            this.setFilter({
                key: 'deal.life_cycle_status',
                value: [
                    DealLifeCycleStatuses.DRAFT,
                    DealLifeCycleStatuses.IN_PROGRESS,
                    DealLifeCycleStatuses.COMPLETED,
                ]
            })

            this.setDefaultSortOrder('id DESC');

            this.setResourceAndLoad(DealResource);
        },
        methods: {
            showContraForAgreement(agreement) {
                this.$refs.contraModal.open(agreement)
            },
            ...mapActions({
                get: 'dataView/get'
            }),
            markDirty(deal) {
                deal.finance_payment.isDirty = true
            },
            save(payment) {
                this.$set(payment, 'isBusy', true)

                payment.commission_amount = payment.finance_agreement.commission_amount

                PaymentResource.update(payment.id, payment).then(response => {
                    return DealerKit.financeCommission.putFinanceCommission(payment.finance_agreement.id, {
                        amount: payment.finance_agreement.commission_amount,
                        paid_at: payment.finance_agreement.commission_paid_at,
                        payment_method: payment.finance_agreement.commission_payment_method,
                    })
                }).then(response => {
                    this.$set(payment, 'isBusy', false)
                    this.$set(payment, 'isDirty', false)
                    this.get()
                }).catch(e => {
                    handleApiError(e);
                    this.$set(payment, 'isBusy', false)
                })
            },
            getFinancePayment(invoice) {
                for (let i in invoice.payments) {
                    if (PaymentMethods.FINANCE === invoice.payments[i].method) {
                        return invoice.payments[i]
                    }
                }
            },
            formattedPaymentDate(payment) {
                return payment ? Moment(payment).format('YYYY-MM-DD') : null
            },
            changeCommPaidAtDate(payment, e) {
                payment.isDirty = true
                payment.finance_agreement.commission_paid_at = e ? Moment(e).format() : null
            },
            changeCommPaymentMethod(payment, e) {
                payment.isDirty = true
                payment.finance_agreement.commission_payment_method = e

                if (!payment.finance_agreement.commission_paid_at) {
                    payment.finance_agreement.commission_paid_at = Moment().format('YYYY-MM-DD')
                }

                if (!e) {
                    payment.finance_agreement.commission_paid_at = null
                }
            },
            changePaidAtDate(payment, e) {
                payment.isDirty = true
                payment.paid_at = e ? Moment(e).format() : null
            },
            changeFinanceStatus(payment, e) {
                payment.isDirty = true

                if ('waiting' === e) {
                    payment.is_banked = false
                    payment.is_signed = false
                    payment.is_posted = false
                    payment.is_approved = false
                    payment.paid_at = null
                    payment.finance_agreement.commission_paid_at = null
                    payment.finance_agreement.commission_payment_method = null
                } else if ('unsigned' === e) {
                    payment.is_banked = false
                    payment.is_signed = false
                    payment.is_posted = false
                    payment.is_approved = true
                    payment.paid_at = null
                    payment.finance_agreement.commission_paid_at = null
                    payment.finance_agreement.commission_payment_method = null
                } else if ('signed' === e) {
                    payment.is_banked = false
                    payment.is_signed = true
                    payment.is_posted = false
                    payment.is_approved = true
                    payment.paid_at = null
                    payment.finance_agreement.commission_paid_at = null
                    payment.finance_agreement.commission_payment_method = null
                } else if ('paid' === e) {
                    payment.is_banked = false
                    payment.is_signed = true
                    payment.is_posted = true
                    payment.is_approved = true
                    payment.paid_at = null
                    payment.finance_agreement.commission_paid_at = null
                    payment.finance_agreement.commission_payment_method = null
                } else if ('banked' === e) {
                    payment.is_banked = true
                    payment.is_signed = true
                    payment.is_posted = true
                    payment.is_approved = true
                    payment.paid_at = Moment().format('YYYY-MM-DD')
                }
            },
        },
        computed: {
            ...mapState({ 
                title: state => state.dataView.title,
                currentFilters: state => state.dataView.currentFilters,
            }),
            totalAgreements() {
                return this.results ? this.results.results.length : 0
            },
            totalAmountFunded() {
                return this.results ? sumBy(this.results.results, 'finance_payment.finance_agreement.amount_funded') : 0
            },
            totalContra() {
                return this.results ? sumBy(this.results.results, 'finance_payment.finance_agreement.total_contra_amount') : 0
            },
            totalPayout() {
                return this.results ? sumBy(this.results.results, 'finance_payment.finance_agreement.payout_amount') : 0
            },
            totalCommission() {
                return this.results ? sumBy(this.results.results, 'finance_payment.finance_agreement.commission_amount') : 0
            },
            viewOptions() {
                return [
                    { 
                        label:'Un-Banked',
                        filters: {
                            'deal.finance_status': 'unbanked',
                            'deal.life_cycle_status': [
                                DealLifeCycleStatuses.DRAFT,
                                DealLifeCycleStatuses.IN_PROGRESS,
                                DealLifeCycleStatuses.COMPLETED,
                            ]
                        },
                        sort: 'id DESC'
                    },
                    {
                        label:'Un-paid Commission',
                        filters: {
                            'deal.finance_commission_payment_status': 0,
                            'deal.life_cycle_status': [
                                DealLifeCycleStatuses.COMPLETED,
                            ]
                        },
                        sort: 'handoverBooking.from DESC'
                    },
                    {
                        type: 'divider'
                    },
                    { 
                        label:'Awaiting Approval',
                        filters: {
                            'deal.finance_status': 'waiting',
                            'deal.life_cycle_status': [
                                DealLifeCycleStatuses.DRAFT,
                                DealLifeCycleStatuses.IN_PROGRESS,
                                DealLifeCycleStatuses.COMPLETED,
                            ]
                        },
                        sort: 'id DESC'
                    },
                    { 
                        label:'Un-Signed',
                        filters: {
                            'deal.finance_status': 'unsigned',
                            'deal.life_cycle_status': [
                                DealLifeCycleStatuses.DRAFT,
                                DealLifeCycleStatuses.IN_PROGRESS,
                                DealLifeCycleStatuses.COMPLETED,
                            ]
                        },
                        sort: 'id DESC'
                    },
                    { 
                        label:'Signed',
                        filters: {
                            'deal.finance_status': 'signed',
                            'deal.life_cycle_status': [
                                DealLifeCycleStatuses.DRAFT,
                                DealLifeCycleStatuses.IN_PROGRESS,
                                DealLifeCycleStatuses.COMPLETED,
                            ]
                        },
                        sort: 'id DESC'
                    },
                    { 
                        label:'Paid Out',
                        filters: {
                            'deal.finance_status': 'paid',
                            'deal.life_cycle_status': [
                                DealLifeCycleStatuses.DRAFT,
                                DealLifeCycleStatuses.IN_PROGRESS,
                                DealLifeCycleStatuses.COMPLETED,
                            ]
                        },
                        sort: 'created_at DESC'
                    },
                    { 
                        label:'Banked',
                        filters: {
                            'deal.finance_status': 'banked',
                            'deal.life_cycle_status': [
                                DealLifeCycleStatuses.DRAFT,
                                DealLifeCycleStatuses.IN_PROGRESS,
                                DealLifeCycleStatuses.COMPLETED,
                            ]
                        },
                        sort: 'handoverBooking.from DESC'
                    }
                ].concat(this.savedViewMenuOptions);
            },
            financeDeals() {
                return this.results.results.map(item => {
                    let finance_payment = this.getFinancePayment(item.invoice)

                    finance_payment.status = 'waiting'

                    if (finance_payment.is_posted && finance_payment.is_approved && finance_payment.is_banked) {
                        finance_payment.status = 'banked'
                    } else if (finance_payment.is_posted && finance_payment.is_approved) {
                        finance_payment.status = 'paid'
                    } else if (finance_payment.is_approved && finance_payment.is_signed) {
                        finance_payment.status = 'signed'
                    } else if (finance_payment.is_approved) {
                        finance_payment.status = 'unsigned'
                    }

                    this.$set(item, 'finance_payment', finance_payment)

                    return item
                })
            },
            financeStatuses() {
                return [
                    { value: 'waiting', label: 'Awaiting Decision'}, 
                    { value: 'unsigned', label: 'Un-Signed'},
                    { value: 'signed', label: 'Signed'},
                    { value: 'paid', label: 'Paid Out'},
                    { value: 'banked', label: 'Banked'}
                ]
            },
            paymentMethodList() {
                return PaymentMethodKeyValueList.filter(item => {
                    return [PaymentMethods.CHEQUE, PaymentMethods.BANK_TRANSFER].includes(item.value)
                })
            },
            tableHeaderColumns() {
                return [
                    { label: 'Customer / Vehicle', style: 'width: 15%;' },
                    { label: 'Deal #', style: 'min-width: 80px;' },
                    { label: 'Funder', style: 'min-width: 150px;' },
                    { label: '£\'s Funded', style: 'width: 150px;' },
                    { label: '£\'s Contra', style: 'width: 150px;' },
                    { label: '£\'s Payout', style: 'width: 150px;' },
                    { label: 'Type', style: 'min-width: 60px;' },
                    { label: 'Term', style: 'min-width: 70px;' },
                    { label: '£\'s P/M', style: 'min-width: 110px;' },
                    { label: '£\'s Balloon', style: 'min-width: 110px;' },
                    { label: 'Status' },
                    { label: 'Payment Date', style: 'width: 170px;' },
                    { label: '£\'s Comm', style: 'min-width: 110px;' },
                    { label: 'Comm Pmt. Method', style: 'width: 170px;' },
                    { label: 'Comm Paid Date', style: 'width: 170px;' },
                    { label: '', style: 'width: 60px;' },
                ];
            },
        }
    }
</script>